<template>
    <!-- https://www.svgrepo.com/svg/404673/chat-message-communication-interaction-talk-conversation -->
    <svg
        width="20px"
        height="20px"
        viewBox="0 0 500 500"
        enable-background="new 0 0 500 500"
        id="Layer_1"
        version="1.1"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <path
                d="M403.314,351.269c106.97-90.589,4.901-213.844-113.9-189.552c-24.973-34.658-65.075-60.083-109.721-59.453   c-72.088-3.63-141.988,63.385-125.637,137.218c4.247,20.794,14.209,38.874,27.182,55.431c0.787,5.06-4.349,10.626-5.645,15.795   c-6.372,15.793-13.746,31.325-18.318,47.763c-0.19,0.995,0.816,1.682,1.465,0.742c92.316-72.557,19.427-28.628,133.726-40.865   c20.395,38.183,63.234,58.92,105.168,62.129c24.919,1.998,49.026-1.549,72.192-11.075c10.543,2.259,20.164,11.172,30.387,15.601   c9.25,4.731,18.279,10.477,28.473,12.876c-9.457-13.671-17.459-28.315-25.977-42.595   C401.381,352.985,401.46,353.054,403.314,351.269z"
                fill="#58454D"
            />

            <path
                d="M59.924,354.842l25.608-60.366c-33.877-34.448-46.048-114.012,7.303-156.956   c63.047-53.691,159.856-31.871,192.148,29.181c113.588-26.964,225.173,89.339,112.984,186.323l26.036,42.746l-51.496-29.783   c-49.682,21.978-150.032,12.563-179.179-51.676c-11.486,3.825-69.017,5.794-81.471-0.916l-49.622,41.639L59.924,354.842z"
                fill="#F6AF52"
            />

            <path
                d="M355.669,366.989c6.161-2.498,14.851-18.308,20.109-11.66c11.323,10.96,24.743,20.048,38.068,28.216   c2.044,2.474,4.088,4.949,6.132,7.423c-0.081,0.092-0.161,0.184-0.242,0.276c-14.35-9.981-29.215-19.185-44.06-28.404   C369.15,359.23,362.416,366.389,355.669,366.989z"
                fill="#F19437"
            />

            <path
                d="M257.796,136.599c-31.979-16.052-69.789-27.976-105.759-19.12c-58.927,13.121-103.498,74.578-89.5,134.52   C27.059,138.164,173.499,66.469,257.796,136.599z"
                fill="#F8C06F"
            />

            <path
                d="M441.198,260.241c-2.829-39.898-34.473-72.122-70.769-85.46v0c-1.115-0.171-1.918-1.232-3.163-1.163   c0,0,0,0,0,0c-16.114-5.308-33.525-9.388-50.474-8.287c65.473,12.703,143.858,68.848,108.83,143.326   c-6.451,16.559-21.588,27.345-29.814,42.542C422.305,328.538,444.883,296.753,441.198,260.241z"
                fill="#F8C06F"
            />

            <path
                d="M276.221,371.741c-24.577-23.926-45.17-52.995-51.796-87.241c-5.757-30.846-5.372-64.835,14.324-90.841v0   c3.155-3.62,6.002-7.623,9.36-11.141c-95.936,51.63-73.6,168.598,29.836,191.732C277.586,373.265,276.872,372.518,276.221,371.741z   "
                fill="#F29335"
            />

            <path
                d="M281.878,161.529c-4.633-6.775-9.578-13.556-15.884-18.867c-12.01,17.68-32.444,26.315-47.053,41.426   c-10.375,10.535-18.523,23.378-25.683,35.931c-0.635-0.124-1.036,0.186-1.247,0.704c-1.414,2.331-3.605,3.458-6.197,3.657   c-8.703,0.3-11.395-8.588-4.135-13.549c-0.541-0.979,0.785-1.014,0.862-1.684c-13.843,0.069-8.243,24.009,5.028,19.174   c0.505-0.291,1.205,0.064,0.668,0.661c-10.883,23.349-22.656,47.873-42.049,65.37c-11.284,9.472-26.932,8.255-40.696,9.913   c-6.114-0.111-9.621,3.947-13.685,7.879c-5.075,2.747-9.31,6.726-14.2,9.716c-0.039,0.184-0.078,0.368-0.117,0.551   c-5.664,11.493-10.978,23.17-17.061,34.461c14.55-13.884,29.599-27.122,44.006-41.102c0.157,0.061,0.314,0.121,0.469,0.185   c0.164-2.163,2.708-1.607,2.68-3.569c7.471-0.891,15.326,3.127,23.041,3.171c0.002-0.002,0.002-0.004,0.005-0.005   c8.445,2.358,56.199,3.414,59.125-3.47c-20.659-46.294,2.011-100.231,42.981-126.839c14.819-10.267,31.086-17.369,48.498-21.917   C282.804,162.915,282.801,162.917,281.878,161.529z"
                fill="#F29335"
            />

            <path
                d="M155.299,312.996c0.007,0.001,0.014,0.002,0.022,0.003C155.302,312.967,155.289,312.961,155.299,312.996z"
                fill="#58454D"
            />

            <path
                d="M403.314,351.269c106.97-90.589,4.901-213.844-113.9-189.552c-24.973-34.658-65.075-60.083-109.721-59.453   c-72.088-3.63-141.988,63.385-125.637,137.218c4.247,20.794,14.209,38.874,27.182,55.431c0.787,5.06-4.349,10.626-5.645,15.795   c-6.372,15.793-13.746,31.325-18.318,47.763c-0.19,0.995,0.816,1.682,1.465,0.742c92.316-72.557,19.427-28.628,133.726-40.865   c20.395,38.183,63.234,58.92,105.168,62.129c24.919,1.998,49.026-1.549,72.192-11.075c10.543,2.259,20.164,11.172,30.387,15.601   c9.25,4.731,18.279,10.477,28.473,12.876c-9.457-13.671-17.459-28.315-25.977-42.595   C401.381,352.985,401.46,353.054,403.314,351.269z M187.508,311.573c-13.461,2.922-27.542,3.712-41.226,2.845   c-5.109-0.144-10.171-0.711-15.185-1.704c-0.002,0.002-0.002,0.004-0.004,0.005c-7.574,0.12-15.578-4.408-22.783-2.887   c-14.315,15.17-30.691,28.539-45.697,43.192c5.934-11.015,11.119-22.405,16.643-33.618c0.039-0.179,0.076-0.359,0.114-0.538l0,0   c3.606-7.125,6.477-14.685,10.208-21.711c0.77-0.987,0.512-1.749-0.035-2.637c-9.534-13.535-19.286-27.19-24.255-43.196l0,0   c-36.6-121.539,129.397-188.364,205.724-99.124c1.204,1.937,10.778,11.913,7.007,12.012c-16.988,4.437-32.857,11.365-47.315,21.38   c-39.967,25.955-62.437,79.059-42.283,124.215C188.913,310.989,188.637,311.31,187.508,311.573z M395.723,348.826   c-0.729,1.319-3.654,2.583-2.673,4.394c5.767,9.772,11.778,19.416,18.706,28.424l0,0c1.949,2.359,3.897,4.717,5.845,7.075   c-0.077,0.088-0.154,0.175-0.231,0.263c-9.096-4.842-41.34-31.039-48.636-27.534c-29.118,11.919-62.321,15.1-92.953,7.587   c-148.187-41.14-91.907-205.023,45.098-202.19c0,0,0,0,0,0c1.31,0.029,2.62,0.059,3.93,0.088c0,0,0,0,0,0   c14.576,0.779,29.223,3.513,43.028,8.398c0,0,0,0,0,0c1.217-0.067,2,0.969,3.09,1.136v0   C452.064,207.692,463.409,295.379,395.723,348.826z"
                fill="#58454D"
            />

            <path
                d="M184.611,111.804c-4.041,0.002-8.082,0.003-12.123,0.005C176.503,111.459,180.615,111.375,184.611,111.804z   "
                fill="#F6AF52"
            />

            <path
                d="M106.049,313.039c-0.315-1.725-0.004-2.085,1.423-1.649C107.062,311.995,106.678,312.623,106.049,313.039z"
                fill="#F29335"
            />

            <path
                d="M171.339,111.866c-1.093,0.489-2.239,0.163-3.36,0.218C169.082,111.753,170.211,111.827,171.339,111.866z"
                fill="#F6AF52"
            />

            <path
                d="M328.18,167.814c-1.125-0.049-2.272,0.26-3.371-0.206C325.94,167.556,327.073,167.474,328.18,167.814z"
                fill="#F6AF52"
            />

            <path
                d="M147.425,214.136c0.107,7.292-11.348,7.292-11.241-0.001C136.078,206.844,147.532,206.844,147.425,214.136z   "
                fill="#EFE9E0"
            />

            <path
                d="M189.784,217.798c0.107,7.292-11.348,7.292-11.241-0.001C178.436,210.505,189.891,210.505,189.784,217.798z   "
                fill="#EFE9E0"
            />

            <path
                d="M277.072,262.188c0.107,7.292-11.348,7.292-11.241,0C265.725,254.896,277.179,254.895,277.072,262.188z"
                fill="#EFE9E0"
            />

            <path
                d="M323.99,263.855c0.107,7.292-11.348,7.292-11.241,0C312.643,256.563,324.097,256.563,323.99,263.855z"
                fill="#EFE9E0"
            />

            <path
                d="M368.938,264.786c0.107,7.292-11.348,7.292-11.241-0.001C357.591,257.494,369.046,257.494,368.938,264.786z   "
                fill="#EFE9E0"
            />

            <path
                d="M270.892,253.611c-11.222,0.148-9.712,17.629,0.911,17.266   C283.231,270.816,281.903,253.102,270.892,253.611z M271.743,266.73c-5.566,0.161-6.786-8.996-0.73-9.085   C276.566,257.329,277.693,266.785,271.743,266.73z"
                fill="#58454D"
            />

            <path
                d="M318.554,255.461c-10.447-0.248-11.516,16.988-0.48,16.789   C328.568,272.374,329.682,255.453,318.554,255.461z M317.972,268.25c-5.718-0.172-4.707-9.064,0.706-8.877   C324.331,259.47,323.363,268.51,317.972,268.25z"
                fill="#58454D"
            />

            <path
                d="M363.145,256.82c-10.493-0.182-10.425,15.897,0.016,15.704C373.653,272.709,373.587,256.683,363.145,256.82   z M363.345,268.87c-5.646,0.07-5.858-8.301-0.084-8.167C368.923,260.713,369.149,268.954,363.345,268.87z"
                fill="#58454D"
            />

            <path
                d="M141.633,205.663c-10.206-0.104-10.257,16.28,0.113,16.244C152.21,222.11,152.123,205.529,141.633,205.663z    M141.784,218.435c-5.205-0.003-5.422-8.748,0.014-8.599C147.031,209.844,147.218,218.538,141.784,218.435z"
                fill="#58454D"
            />

            <path
                d="M186.957,211.057c-10.291-3.43-15.483,12.023-3.995,13.732   C191.339,227.076,196.206,213.311,186.957,211.057z M185.362,220.878c-2.368,0.601-5.334-1.184-5.18-3.353   C181.631,210.147,194.313,217.447,185.362,220.878z"
                fill="#58454D"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "ChatBubbleIcon",
};
</script>

<style scoped></style>
